import type { App, } from "vue"
import { createI18n, } from "vue-i18n"
import { useLocale, } from "@/hooks/useLocale.ts"

const { localeState, } = useLocale()

export type I18n = typeof i18n

export const i18n = createI18n({
  legacy: false,
  messages: {
    [LocaleEnum.ZH_CN]: {},
    [LocaleEnum.EN_US]: {},
  },
  locale: localeState.value,
  fallbackLocale: LocaleEnum.ZH_CN,
},)

export function setupI18n(app: App<Element>,) {
  app.use(i18n,)
  app.provide("i18n", i18n,)
}
